import { render } from "./ReviewExportFile.vue?vue&type=template&id=77c06956"
import script from "./ReviewExportFile.vue?vue&type=script&lang=js"
export * from "./ReviewExportFile.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__